import { c as _c } from "react/compiler-runtime";
import Button from '@mui/material/Button';
import { RouterLink } from 'src/routes/components';
import { useTranslate } from 'src/locales';
import { useRedirectToSignIn } from '../hooks';

// ----------------------------------------------------------------------

export function SignInButton(t0) {
  const $ = _c(14);
  let other;
  let sx;
  if ($[0] !== t0) {
    ({
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = other;
    $[2] = sx;
  } else {
    other = $[1];
    sx = $[2];
  }
  const {
    t
  } = useTranslate();
  const urlToSignIn = useRedirectToSignIn();
  let t1;
  if ($[3] !== sx) {
    t1 = Array.isArray(sx) ? sx : [sx];
    $[3] = sx;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = [...t1];
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("Sign in");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== other || $[10] !== t2 || $[11] !== t3 || $[12] !== urlToSignIn) {
    t4 = <Button fullWidth={true} size="large" href={urlToSignIn} variant="contained" component={RouterLink} sx={t2} {...other}>{t3}</Button>;
    $[9] = other;
    $[10] = t2;
    $[11] = t3;
    $[12] = urlToSignIn;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}